import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { BatchRequestsService } from './api/batchRequests.service';
import { BestFmcSetService } from './api/bestFmcSet.service';
import { BomMcolDataSetService } from './api/bomMcolDataSet.service';
import { ColourSetService } from './api/colourSet.service';
import { ControlRecordSetService } from './api/controlRecordSet.service';
import { DIRFilesSetService } from './api/dIRFilesSet.service';
import { DefaultInitDataSetService } from './api/defaultInitDataSet.service';
import { DigitalAssetDataSetService } from './api/digitalAssetDataSet.service';
import { DocInfoRecordSetService } from './api/docInfoRecordSet.service';
import { InitDataSetService } from './api/initDataSet.service';
import { InitFieldAttribSetService } from './api/initFieldAttribSet.service';
import { MatClCharactersticSetService } from './api/matClCharactersticSet.service';
import { MatFieldAttribSetService } from './api/matFieldAttribSet.service';
import { MatNumberPacketItemSetService } from './api/matNumberPacketItemSet.service';
import { MatNumberPacketSetService } from './api/matNumberPacketSet.service';
import { MaterialAlternativeUomListSetService } from './api/materialAlternativeUomListSet.service';
import { MaterialConfidentialDescriptionSetService } from './api/materialConfidentialDescriptionSet.service';
import { MaterialDataSetService } from './api/materialDataSet.service';
import { MaterialDescriptionSetService } from './api/materialDescriptionSet.service';
import { MaterialHistorySetService } from './api/materialHistorySet.service';
import { MaterialNotificationScreenSetService } from './api/materialNotificationScreenSet.service';
import { MaterialQrCodeDataSetService } from './api/materialQrCodeDataSet.service';
import { MaterialSearchSetService } from './api/materialSearchSet.service';
import { MaterialTextSetService } from './api/materialTextSet.service';
import { MaterialUomBomScreenSetService } from './api/materialUomBomScreenSet.service';
import { MaterialUomPrintLabelsSetService } from './api/materialUomPrintLabelsSet.service';
import { MaterialUomSetService } from './api/materialUomSet.service';
import { McolDataSetService } from './api/mcolDataSet.service';
import { NotifActivitySetService } from './api/notifActivitySet.service';
import { NotifSetService } from './api/notifSet.service';
import { Plant500DataSetService } from './api/plant500DataSet.service';
import { PlantDataSetService } from './api/plantDataSet.service';
import { PrepackDataSetService } from './api/prepackDataSet.service';
import { PrepackProfileSetService } from './api/prepackProfileSet.service';
import { PrepackSiblingSetService } from './api/prepackSiblingSet.service';
import { ShAgeMarkSetService } from './api/shAgeMarkSet.service';
import { ShAltUoMSetService } from './api/shAltUoMSet.service';
import { ShAssemblyMethodService } from './api/shAssemblyMethod.service';
import { ShBaseUnitSetService } from './api/shBaseUnitSet.service';
import { ShBoxTicketCarrierCodeSetService } from './api/shBoxTicketCarrierCodeSet.service';
import { ShColourCodeSetService } from './api/shColourCodeSet.service';
import { ShCommodityCodeSetService } from './api/shCommodityCodeSet.service';
import { ShCrossPlantStatusSetService } from './api/shCrossPlantStatusSet.service';
import { ShDevOwnerSetService } from './api/shDevOwnerSet.service';
import { ShDevelopmentSegmentSetService } from './api/shDevelopmentSegmentSet.service';
import { ShDocumentNumberSetService } from './api/shDocumentNumberSet.service';
import { ShDocumentTypeSetService } from './api/shDocumentTypeSet.service';
import { ShEmployeeMasterDataSetService } from './api/shEmployeeMasterDataSet.service';
import { ShGlobalBuyerSetService } from './api/shGlobalBuyerSet.service';
import { ShGlobalStatusCodeControlUserSetService } from './api/shGlobalStatusCodeControlUserSet.service';
import { ShGlobalStatusSetService } from './api/shGlobalStatusSet.service';
import { ShGtinCategorySetService } from './api/shGtinCategorySet.service';
import { ShItemGroupSetService } from './api/shItemGroupSet.service';
import { ShLanguageSetService } from './api/shLanguageSet.service';
import { ShLaunchIdSetService } from './api/shLaunchIdSet.service';
import { ShLdpProcessSetService } from './api/shLdpProcessSet.service';
import { ShLicenseRoyaltySetService } from './api/shLicenseRoyaltySet.service';
import { ShLowLvlUomSetService } from './api/shLowLvlUomSet.service';
import { ShMainGroupSetService } from './api/shMainGroupSet.service';
import { ShMarketPrioritySetService } from './api/shMarketPrioritySet.service';
import { ShMatByDescrSetService } from './api/shMatByDescrSet.service';
import { ShMatLegoGeneralSetService } from './api/shMatLegoGeneralSet.service';
import { ShMaterialGroupSetService } from './api/shMaterialGroupSet.service';
import { ShMaterialTypeSetService } from './api/shMaterialTypeSet.service';
import { ShPackSubLevelSetService } from './api/shPackSubLevelSet.service';
import { ShPackagingFacingSetService } from './api/shPackagingFacingSet.service';
import { ShPartCodeSetService } from './api/shPartCodeSet.service';
import { ShPartTypeSetService } from './api/shPartTypeSet.service';
import { ShPlanningCategorySetService } from './api/shPlanningCategorySet.service';
import { ShProdHierarchySetService } from './api/shProdHierarchySet.service';
import { ShProductCategorySetService } from './api/shProductCategorySet.service';
import { ShProductClassSetService } from './api/shProductClassSet.service';
import { ShProductCompositionSetService } from './api/shProductCompositionSet.service';
import { ShProductManagerSetService } from './api/shProductManagerSet.service';
import { ShProductSubClassSetService } from './api/shProductSubClassSet.service';
import { ShProductVersionSetService } from './api/shProductVersionSet.service';
import { ShSalesCategorySetService } from './api/shSalesCategorySet.service';
import { ShScrapTypeSetService } from './api/shScrapTypeSet.service';
import { ShSubMainGroupSetService } from './api/shSubMainGroupSet.service';
import { ShSuperCategorySetService } from './api/shSuperCategorySet.service';
import { ShSuperThemeSetService } from './api/shSuperThemeSet.service';
import { ShSupplyChainOwnerSetService } from './api/shSupplyChainOwnerSet.service';
import { ShTopMainGroupSetService } from './api/shTopMainGroupSet.service';
import { ShUserByNameSetService } from './api/shUserByNameSet.service';
import { ShValueByDomainSetService } from './api/shValueByDomainSet.service';
import { ShVendorGeneralSetService } from './api/shVendorGeneralSet.service';
import { ShWBSElementSetService } from './api/shWBSElementSet.service';
import { StLocation500DataSetService } from './api/stLocation500DataSet.service';
import { SystemInfoSetService } from './api/systemInfoSet.service';
import { Valuation500DataSetService } from './api/valuation500DataSet.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class MaterialApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<MaterialApiModule> {
        return {
            ngModule: MaterialApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: MaterialApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('MaterialApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
